var map = {
	"./addr-book.svg": "5b7b",
	"./addr-card.svg": "6f86",
	"./books.svg": "cd6f",
	"./briefcase.svg": "19b69",
	"./building.svg": "d439",
	"./chart.svg": "3653",
	"./checkbox.svg": "eca4",
	"./chevron.svg": "3e50",
	"./cross-patient-card.svg": "6591",
	"./cross.svg": "3a4d",
	"./delete.svg": "571d",
	"./expanded-icon.svg": "6db6",
	"./eye-closed.svg": "8fb5",
	"./eye.svg": "083f",
	"./filter.svg": "bcee",
	"./grid.svg": "14a4",
	"./group-of-risk.svg": "2166",
	"./hamburger.svg": "7b81",
	"./list.svg": "484a",
	"./logout.svg": "a861",
	"./mail.svg": "4f1b",
	"./pen.svg": "c62c",
	"./refresh.svg": "d47a",
	"./search.svg": "0a17",
	"./searchSvg.svg": "10ce",
	"./settings.svg": "bc64",
	"./support.svg": "b0d4",
	"./table-document-icon.svg": "7dfa",
	"./thumbs-up.svg": "950e",
	"./tmp-patients-status-0.svg": "5df8",
	"./tmp-patients-status-1.svg": "d6aa",
	"./tmp-patients-status-2.svg": "4256",
	"./tmp-patients-status-3.svg": "9c02",
	"./tmp-patients-status-4.svg": "2416",
	"./tmp-patients-status-5.svg": "ddc6",
	"./tmp-patients-status-6.svg": "17a0",
	"./tmp-patients-status-7.svg": "4e62",
	"./tmp-patients-status-8.svg": "3283",
	"./tmp-patients-status-9.svg": "b1a2",
	"./trash-restore.svg": "7513",
	"./trash.svg": "9961",
	"./user-settings.svg": "bd20",
	"./warning.svg": "45a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";